export const shouldUseOauthRedirect = (): boolean => {
    if (typeof window === 'undefined') {
        return false
    }

    const ua = window.navigator.userAgent
    const isIosDevice = /iPad|iPhone|iPod/i.test(ua)
    const isIpadOs = window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1

    return isIosDevice || isIpadOs
}
